module.exports = __webpack_public_path__ + "img/help_banner.9bd2e503.jpg";